import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import classNames           from 'classnames';
import ActiveRadioIcon      from 'react-icons/lib/fa/circle';
import RadioIcon            from 'react-icons/lib/fa/circle-o';
import FieldError           from '../Fragments/FieldError';

let Validation = require('../Managers/Validation.js');
let Quote = require('../Managers/Quote.js');

class RadioGroupInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeValue: props.defaultValue ? props.defaultValue : null,
            hasError: false,
            isValid: false,
            showOtherActiveValues: false,
        };
    }

    componentWillMount() {
        if (window.uornorb(this.props.defaultValue)) {
            return false;
        }

        // if we have a default value, we presume that we're valid
        this.setState({isValid: true});
        this.props.isValid(true);

        // if we have an onLoadFunction, call that.
        // otherwise, call the callback
        if (this.props.onLoadFunction) {
            this.props.onLoadFunction(this.props.fieldName, this.props.defaultValue, this);
        } else if (this.props.callbackFunction) {
            this.props.callbackFunction(this.props.fieldName, this.props.defaultValue, this);
        }

        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    handleValidation(value) {
        this.setActiveValue(value);
    }

    setActiveValue(value) {
        let validation = Validation.validate(this.props.dataValidation, value)[0];

        if (!window.uorn(validation)) {
            this.setState(Object.assign({}, validation, { activeValue: value }), () => {
                this.props.isValid(validation.isValid);
            });
        } else {
            this.setState(Object.assign({ activeValue: value }), () => {
                this.props.isValid(true);
            });
        }

        Quote.set(this.props.storageKey, value, this.props.source);

        if (this.props.callbackFunction) {
            this.props.callbackFunction(this.props.fieldName, value, this);
        }
    }

    render() {
        let questionClasses = classNames({
            'question-input': true,
            'question-bordered': this.props.questionBorder,
            'with-content': this.props.questionContent
        });

        return (
            <div>
                <div className={questionClasses}>
                    <div className={`row-${this.props.columns} row-constrained`}>
                        {this.props.options.map(function(choice, index) {
                            return(
                                <div key={index} className="column" onClick={this.setActiveValue.bind(this, choice.value)}>
                                    <div className="radio pointer">
                                        {this.state.activeValue == choice.value ?
                                            <ActiveRadioIcon className="icon active" />
                                        :
                                            <RadioIcon className="icon" />
                                        }
                                        <span>{choice.text}</span>
                                    </div>
                                </div>
                            );
                        }, this)}
                    </div>
                    {this.props.questionContent ?
                        <div dangerouslySetInnerHTML={{__html: this.props.questionContent}} />
                    : null}
                </div>
                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

RadioGroupInput.propTypes = {
    question:           PropTypes.string.isRequired,
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    options:            PropTypes.array.isRequired,
    children:           PropTypes.array,
    callbackFunction:   PropTypes.func,
    defaultValue:       PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    dataValidation:     PropTypes.string,
    onLoadFunction:     PropTypes.func,
    source:             PropTypes.string,
    isValid:            PropTypes.func,
    columns:            PropTypes.number,
    questionBorder:     PropTypes.bool,
    questionContent:    PropTypes.string,
};

RadioGroupInput.defaultProps = {
    columns: 2,
};

export default RadioGroupInput;



// WEBPACK FOOTER //
// ./src/components/Fields/RadioGroupInput.js